import { Box, Button, ButtonRow, Card, Heading, IconButton } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { IEpisodeCategory } from '@common/interfaces';
import { EmploymentPreferenceName } from '@common/enums';
import { useAbortableFetch } from '@frontend/utils';
import { useFrontendSettings } from '@frontend/utils/hooks/useFrontendSettings';
import { Carousel } from './Carousel';

export function Recommendations() {
    const abortableFetch = useAbortableFetch();
    const employmentPreferenceName = EmploymentPreferenceName.hideCrossSellingComponent;
    const { frontendSettings } = useFrontendSettings();
    const [recommendations, setRecommendations] = useState<IEpisodeCategory[]>([]);
    const [hideCrossSellingComponent, setHideCrossSellingComponent] = useState(true);
    const [showConfirmHideComponent, setShowConfirmHideComponent] = useState(false);

    useEffect(() => {
        getEmploymentPreference();
    }, []);

    useEffect(() => {
        if (!hideCrossSellingComponent) {
            loadRecommendations();
        }
    }, [hideCrossSellingComponent]);

    if (frontendSettings.crossSellingEnabled === false) {
        return <></>;
    }

    if (hideCrossSellingComponent || recommendations.length < 1) {
        return <></>;
    }

    return (
        <Card>
            <Card.Header
                action={
                    <IconButton
                        icon="close"
                        isDisabled={showConfirmHideComponent}
                        onClick={() => setShowConfirmHideComponent(!showConfirmHideComponent)}
                    />
                }
                title="Wil je meer weten over andere vakgebieden?"
            />
            <Card.Body>
                <Carousel recommendations={recommendations} />
            </Card.Body>
            {showConfirmHideComponent && (
                <Box
                    backgroundColor="white"
                    height="100%"
                    left="0"
                    position="absolute"
                    top="0"
                    width="100%"
                    zIndex="10"
                >
                    <Box
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                        px={[4, 6]}
                    >
                        <Heading
                            mb={6}
                            size="medium"
                            textAlign="center"
                        >
                            Je zal voor nu geen aanbevelingen meer zien.
                        </Heading>
                        <ButtonRow justify="center">
                            <Button
                                onClick={updateEmploymentPreference}
                                variant="link"
                            >
                                Toon voorlopig niet meer
                            </Button>
                        </ButtonRow>
                    </Box>
                </Box>
            )}
        </Card>
    );

    async function loadRecommendations() {
        const result = await abortableFetch.fetchJson('/api/episodeCategories/recommendations', 'GET');

        if (result.json.items) {
            setRecommendations(result.json.items);
        }
    }

    async function getEmploymentPreference() {
        const result = await abortableFetch.fetchJson(`/api/employmentPreference/${employmentPreferenceName}`, 'GET');

        setHideCrossSellingComponent(result?.json?.employmentPreference?.[employmentPreferenceName]);
    }

    function updateEmploymentPreference() {
        const body = {
            employmentPreferences: {
                [employmentPreferenceName]: true,
            },
        };

        abortableFetch.fetchJson(`/api/employmentPreference`, 'POST', body);
        setHideCrossSellingComponent(true);
    }
}
